import { useNavigate } from 'react-router-dom';

import { PLRoutes } from '../../enums/routes.enum';
import { SalesTable } from '../../pages/sales/types';
import { CustomPLTable } from '../custom-pl-table';
import { PaymentLinkTableSalesProps } from './types';

const PaymentLinkTableSales = ({
	allowedCustomAction = false,
	allowExport = false,
	exportWithSearch = false,
	handleExportAction,
	columns,
	data,
	filters,
	hasFilters = false,
	hasDateFilters = true,
	hasSearch = false,
	isLoading,
	onFilterChange,
	pagination,
	setPagination,
	titleTable,
	totalResults,
}: PaymentLinkTableSalesProps) => {
	const navigate = useNavigate();

	const handleRedirectAllPayments = () => {
		navigate(PLRoutes.ALL);
	};

	return (
		<CustomPLTable<SalesTable>
			title={titleTable}
			data={data}
			isLoading={!!isLoading}
			columns={columns}
			hasFilters={hasFilters}
			hasDateFilter={hasDateFilters}
			allowCustomaAction={allowedCustomAction}
			customActionText="Ver Todos"
			customAction={() => handleRedirectAllPayments()}
			allowExport={allowExport}
			exportWithSearch={exportWithSearch}
			filters={filters}
			onFilterChange={onFilterChange}
			hasSearch={hasSearch}
			exportAction={handleExportAction}
			hasPagination={!!totalResults && totalResults > 0}
			totalResults={totalResults}
			pagination={pagination}
			setPagination={setPagination}
		/>
	);
};

export { PaymentLinkTableSales };
